var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer text-gray-header-text bg-white h-8 flex justify-end items-center text-sm pr-3 flex-wrap"},[_c('div',[_vm._v(" © Design & Development by"),_c('a',{staticClass:"ml-1",attrs:{"href":"http://thewalkingnerds.com/","target":"blank"}},[_vm._v("TheWalkingNerds")]),_vm._v(". ")])])
}]

export { render, staticRenderFns }